// Mock data for Pravin Gupta & Associates

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1589994965851-a8f479c573a9?auto=format&fit=crop&w=1920&q=80",
    title: "Giving you a lot more than just law",
    subtitle: "We are Voice of Justice",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1568092806323-8ec13dfa9b92?auto=format&fit=crop&w=1920&q=80",
    title: "Quicker. Smarter. Digitalized. Better.",
    subtitle: "We are Voice of Justice",
  },
  {
    id: 3,
    image: "https://images.pexels.com/photos/6077296/pexels-photo-6077296.jpeg?auto=compress&cs=tinysrgb&w=1920",
    title: "Our name is easy to remember and our work is hard to forget.",
    subtitle: "We are Voice of Justice",
  },
  {
    id: 4,
    image: "https://images.pexels.com/photos/5668882/pexels-photo-5668882.jpeg?auto=compress&cs=tinysrgb&w=1920",
    title: "Lawyers you can trust.",
    subtitle: "We are Voice of Justice",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1589578527966-fdac0f44566c?auto=format&fit=crop&w=1920&q=80",
    title: "Practicing the Art of Law",
    subtitle: "We are Voice of Justice",
  },
  {
    id: 6,
    image: "https://images.pexels.com/photos/5669619/pexels-photo-5669619.jpeg?auto=compress&cs=tinysrgb&w=1920",
    title: "Our Business is to give you Peace of Mind.",
    subtitle: "We are Voice of Justice",
  },
  {
    id: 7,
    image: "https://images.pexels.com/photos/6077447/pexels-photo-6077447.jpeg?auto=compress&cs=tinysrgb&w=1920",
    title: "Justice delivered with integrity and precision.",
    subtitle: "We are Voice of Justice",
  },
];

export const stats = [
  { id: 1, value: 5418, label: "Loyal Clients" },
  { id: 2, value: 12650, label: "Meetings & Consultations" },
  { id: 3, value: 9268, label: "Documentations" },
  { id: 4, value: 6348, label: "Court Appearances" },
];

export const services = [
  {
    slug: "redevelopment",
    title: "REDEVELOPMENT",
    icon: "Building2",
    short:
      "Drafting of Development Agreements, POA, Consent Affidavits, and related redevelopment documentation.",
    description:
      "Comprehensive redevelopment services including drafting of Development Agreements, Power of Attorneys, Consent Affidavits, Individual Agreements, MOU with Developers, Permanent Alternate Accommodation Agreements, and representation before all statutory authorities. We assist Housing Societies, Land Owners and Developers through the complete redevelopment lifecycle.",
  },
  {
    slug: "conveyance",
    title: "CONVEYANCE",
    icon: "FileSignature",
    short:
      "Drafting of Conveyance Deed, Sale Deed, Transfer Deed, Release Deed, Gift Deed and related conveyances.",
    description:
      "End-to-end conveyance services including preparation and vetting of Conveyance Deeds, Sale Deeds, Transfer Deeds, Release Deeds, Gift Deeds, Deemed Conveyance applications for Co-operative Housing Societies, and representation before the District Deputy Registrar for grant of Deemed Conveyance.",
  },
  {
    slug: "property-litigations",
    title: "PROPERTY LITIGATIONS",
    icon: "Landmark",
    short:
      "Litigations of whatsoever nature before any court across India with reference to immovable property disputes.",
    description:
      "Representation in property disputes before Civil Courts, High Courts and the Supreme Court of India. We handle title suits, partition suits, specific performance suits, injunction proceedings, eviction and possession matters, and appeals arising out of such litigation.",
  },
  {
    slug: "divorce-litigation",
    title: "DIVORCE LITIGATION",
    icon: "HeartCrack",
    short:
      "Advises and Litigation relating to Divorce, wedlock counseling, mutual consent divorce and maintenance.",
    description:
      "Sensitive and confidential counsel on matrimonial matters including Divorce (contested and mutual consent), Judicial Separation, Restitution of Conjugal Rights, Maintenance under Section 125 CrPC, Domestic Violence proceedings, and Child Custody matters.",
  },
  {
    slug: "criminal-litigations",
    title: "CRIMINAL LITIGATIONS",
    icon: "ShieldAlert",
    short:
      "Litigation under the various provisions of Indian Penal Code, Money Laundering Act, NDPS and more.",
    description:
      "Robust criminal defense and prosecution assistance under the Indian Penal Code, Prevention of Money Laundering Act, NDPS Act, Prevention of Corruption Act, Negotiable Instruments Act (Sec 138), and Economic Offences. Includes anticipatory bail, regular bail, and quashing proceedings.",
  },
  {
    slug: "company-litigation",
    title: "COMPANY LITIGATION",
    icon: "Briefcase",
    short:
      "Formation and Registration of Companies under the provisions of Companies Act and related disputes.",
    description:
      "Advice and representation on incorporation of companies, corporate compliance, shareholder disputes, oppression and mismanagement petitions before the NCLT, insolvency proceedings under the IBC, and appeals before the NCLAT.",
  },
  {
    slug: "cooperative-society-litigation",
    title: "COOPERATIVE & SOCIETY LITIGATION",
    icon: "Users",
    short:
      "Advises and litigation relating to Co-operative Housing Society related Laws.",
    description:
      "Comprehensive advice to Co-operative Housing Societies on registration, bye-laws, election disputes, membership disputes, recovery of dues, redevelopment matters, and litigation before the Registrar, Co-operative Court and Co-operative Appellate Court.",
  },
  {
    slug: "money-recovery-litigation",
    title: "MONEY RECOVERY LITIGATION",
    icon: "IndianRupee",
    short:
      "Advises and Litigation relating to recovery of Money including Summary Suit and Commercial disputes.",
    description:
      "Fast, focused money recovery through Summary Suits (Order 37 CPC), Commercial Suits, Section 138 NI Act proceedings, arbitration for commercial defaults, and execution proceedings for realisation of decreed amounts.",
  },
  {
    slug: "consumer-law-litigations",
    title: "CONSUMER LAW LITIGATIONS",
    icon: "ShoppingBag",
    short: "Litigation of any nature related to protection of rights of consumers.",
    description:
      "Representation of consumers before the District Consumer Commission, State Consumer Commission and National Consumer Commission on deficiency of service, unfair trade practices, defects in goods and builder disputes under RERA.",
  },
  {
    slug: "rent-control-law",
    title: "RENT CONTROL LAW",
    icon: "KeyRound",
    short: "Litigation of whatsoever nature relating to Landlord and Tenant.",
    description:
      "Landlord and Tenant disputes under the Maharashtra Rent Control Act and equivalent state legislations including eviction, standard rent fixation, arrears of rent and enforcement of leave & license agreements.",
  },
  {
    slug: "labour-laws-litigation",
    title: "LABOUR LAWS LITIGATION",
    icon: "HardHat",
    short:
      "Advises and Litigation of whatsoever nature relating to Disputes between Employers and Employees.",
    description:
      "End-to-end advisory and litigation on Industrial Disputes Act, Payment of Wages, ESI, PF, Gratuity, Bonus, Contract Labour and Sexual Harassment (POSH) proceedings. Representation before Labour Court, Industrial Court and Tribunals.",
  },
  {
    slug: "arbitration",
    title: "ARBITRATION",
    icon: "Scale",
    short:
      "Arbitration of disputes before Arbitration Tribunals including international commercial arbitration.",
    description:
      "Full-service arbitration practice covering ad-hoc and institutional arbitration, drafting of arbitration clauses, appointment of arbitrators, Section 9 and Section 17 interim reliefs, Section 34 challenges, and enforcement of awards under Section 36.",
  },
  {
    slug: "information-technology-laws",
    title: "INFORMATION TECHNOLOGY LAWS",
    icon: "Laptop",
    short:
      "Drafting of Agreements with Service Providers, AMC, Online Contracts and IT compliance.",
    description:
      "Advice on the Information Technology Act, data protection, cyber-crime investigations, drafting of Service Level Agreements, End User License Agreements, Terms of Use and Privacy Policies, and representation before adjudicating officers and cyber cells.",
  },
  {
    slug: "intellectual-property-rights",
    title: "INTELLECTUAL PROPERTY RIGHTS (IPR)",
    icon: "Copyright",
    short:
      "Registration of Copyright, Patent, Trademark, Design etc. and related litigation.",
    description:
      "Prosecution and enforcement of Trademarks, Copyrights, Patents and Designs. Filing of oppositions and rectifications, infringement and passing off suits, and takedown notices for online infringement.",
  },
  {
    slug: "registration-of-documents",
    title: "REGISTRATION OF DOCUMENTS",
    icon: "FileText",
    short:
      "Registration of Documents before appropriate Registrars and Sub-Registrars of Assurances.",
    description:
      "Turnkey registration of Sale Deeds, Gift Deeds, Lease Deeds, Leave & License Agreements, Development Agreements and Powers of Attorney before the Sub-Registrar of Assurances, including calculation of stamp duty and adjudication.",
  },
  {
    slug: "real-estate-and-property-transfer",
    title: "REAL ESTATE & PROPERTY TRANSFER",
    icon: "Home",
    short:
      "Advice and Execution of all documents necessary for transfer of Immovable Property.",
    description:
      "Complete real estate advisory covering due diligence, title investigation reports, MOFA compliance, RERA registration and compliance, drafting of Agreements for Sale, and structuring of joint venture and development transactions.",
  },
  {
    slug: "drt-debt-recovery",
    title: "DRT - DEBT RECOVERY",
    icon: "Banknote",
    short:
      "Proceedings before the Debts Recovery Tribunal (DRT) and DRAT under the RDDBFI Act and SARFAESI Act.",
    description:
      "Representation of Banks, Financial Institutions, Asset Reconstruction Companies and Borrowers before the Debts Recovery Tribunal (DRT), Debts Recovery Appellate Tribunal (DRAT) and High Courts. Practice includes original applications for recovery, securitisation applications under Section 17 of the SARFAESI Act, symbolic and physical possession proceedings, DM applications under Section 14, and enforcement of DRT recovery certificates.",
  },
  {
    slug: "mact-motor-accident-claims",
    title: "MACT - MOTOR ACCIDENT CLAIMS",
    icon: "Car",
    short:
      "Claims and defence before the Motor Accidents Claims Tribunal (MACT) for compensation in road accident matters.",
    description:
      "Comprehensive practice before the Motor Accidents Claims Tribunal (MACT) covering claim petitions under Section 166 and Section 163A of the Motor Vehicles Act, no-fault liability claims, hit-and-run compensation, defence for insurance companies, quantum of compensation appeals before the High Court, and enforcement of MACT awards.",
  },
  {
    slug: "income-tax",
    title: "INCOME TAX",
    icon: "Receipt",
    short:
      "Advisory, representation and litigation on Income Tax matters including assessments, appeals and search & seizure.",
    description:
      "End-to-end Income Tax practice: opinion and structuring, scrutiny assessments, reassessment proceedings under Sections 147/148, TDS defaults, search and seizure proceedings, penalty proceedings, appeals before the CIT(A) and ITAT, and further appeals on substantial questions of law before the High Court and Supreme Court.",
  },
];

export const attorneys = [
  {
    id: 1,
    name: "Pravin K. Gupta",
    role: "Advocate & Solicitor - Founder",
    bio: "Founder of Pravin Gupta & Associates. Leading the firm across Property, Redevelopment, Corporate, Criminal, DRT, MACT and Income Tax practice with a strong emphasis on quality, ethics and technology-driven representation.",
  },
  {
    id: 2,
    name: "Chandrakala Jaiswal",
    role: "Junior Advocate",
    bio: "Junior Advocate assisting the firm on trial court appearances, drafting of pleadings and client conferences across civil and matrimonial matters.",
  },
  {
    id: 3,
    name: "Prasad Helkar",
    role: "Junior Advocate",
    bio: "Junior Advocate handling day-to-day court work, filings and coordination across the firm's litigation practice.",
  },
  {
    id: 4,
    name: "Manoj Chaurasiya",
    role: "Junior Advocate",
    bio: "Junior Advocate contributing to research, drafting and appearances in civil and criminal matters before the trial courts.",
  },
  {
    id: 5,
    name: "Kajal Singh",
    role: "Intern",
    bio: "Legal intern assisting the team on legal research, case-law compilation and drafting under the guidance of the senior advocates.",
  },
  {
    id: 6,
    name: "Sahil Gupta",
    role: "Intern",
    bio: "Legal intern supporting the firm with research, drafting and case preparation across practice areas.",
  },
  {
    id: 7,
    name: "Arpana Gupta",
    role: "Supporting Staff",
    bio: "Supporting staff managing office coordination, client scheduling and day-to-day operations of the firm.",
  },
  {
    id: 8,
    name: "Arshad Kureshi",
    role: "Supporting Staff",
    bio: "Supporting staff handling court filings, movement of files and administrative coordination for the litigation team.",
  },
];

export const timeSlots = [
  "10.00 am - 11.00 am",
  "11.00 am - 12.00 pm",
  "12.00 pm - 1.00 pm",
  "1.00 pm - 2.00 pm",
  "2.00 pm - 3.00 pm",
  "3.00 pm - 4.00 pm",
  "4.00 pm - 5.00 pm",
  "5.00 pm - 6.00 pm",
  "6.00 pm - 7.00 pm",
];

export const contactInfo = {
  firmName: "Pravin Gupta & Associates",
  founder: "Adv. Pravin K. Gupta",
  phone: "+91 92247 81820",
  altPhone: "+91 92247 81820",
  email: "advocarepravingupta820@gmail.com",
  altEmail: "info@pravinguptaandassociates.com",
  website: "pravinguptaandassociates.com",
  address:
    "Office No. 14, Shriganesh Sai CHS, VIT College Road, Near Shriji Tower, Wadala East, Mumbai - 400 037",
  hours: [
    { day: "Monday - Saturday", time: "10.00 am - 10.00 pm" },
    { day: "Sunday", time: "10.00 am - 05.00 pm" },
  ],
};
